import { AttachmentParams } from './attachments.types';
import { selectCurrentProposalId } from 'store/proposals';
import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './attachments.consts';

export const fetchAllAttachmentsOfProposal = createAsyncThunk(
  REDUCER_KEY + '/fetchAllAttachments',
  withErrorHandling(async ({ proposalId }: { proposalId: number }) => {
    const response = await adserver({
      url: `/proposal/${proposalId}/attachments`,
      headers: {},
    });
    return response.data.map((attachment: AttachmentParams) => ({
      ...attachment,
      proposalId: proposalId,
    }));
  }),
);

export const fetchAllAttachmentsOfCurrentProposal = createAsyncThunk(
  REDUCER_KEY + '/fetchAllAttachmentsOfCurrentProposal',
  withErrorHandling(async (_: any, thunkApi: any) => {
    const proposalId = selectCurrentProposalId(thunkApi.getState());
    const response = await adserver({
      url: `/proposal/${proposalId}/attachments`,
      headers: {},
    });

    return response.data.map((attachment: AttachmentParams) => ({
      ...attachment,
      proposalId: proposalId,
    }));
  }),
);

export const createAttachment = createAsyncThunk(
  REDUCER_KEY + '/createAttachment',
  withErrorHandling(
    async ({
      proposalId,
      formData,
    }: {
      proposalId: number;
      formData: FormData;
    }) => {
      const response = await adserver({
        url: `/proposal/${proposalId}/attachment/`,
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return { ...response.data, proposalId: proposalId };
    },
  ),
);

export const deleteAttachment = createAsyncThunk(
  REDUCER_KEY + '/deleteAttachment',
  withErrorHandling(
    async ({
      proposalId,
      attachmentId,
    }: {
      proposalId: number;
      attachmentId: number;
    }) => {
      await adserver({
        url: `/proposal/${proposalId}/attachment/${attachmentId}`,
        method: 'DELETE',
        headers: {},
      });
      return attachmentId;
    },
  ),
);

export const getAttachment = createAsyncThunk(
  REDUCER_KEY + '/getAttachment',
  withErrorHandling(
    async ({
      proposalId,
      attachmentId,
    }: {
      proposalId: number;
      attachmentId: number;
    }) => {
      const response = await adserver({
        url: `/proposal/${proposalId}/attachment/${attachmentId}`,
        method: 'GET',
        headers: {},
      });

      return { ...response.data, proposalId: proposalId };
    },
  ),
);
